#import '../fragment/contractNoDates.graphql'

fragment contractFragment on Contract {
  ...contractNoDatesFragment
  startDate
  endDate
}
